import * as React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons';
import {useTranslation} from '@deviceinsight/ng-ui-scale-lib/api';

type Props = {
	deactivatedBySystem: boolean;
};

const RuleDeactivationWarning = ({deactivatedBySystem}: Props) => {
	const {t} = useTranslation();

	const mouseHoverText = t('ruleengine.ruleDeactivationWarning', {
		defaultValue:
			'This Rule was deactivated by the system because at least one of the consisting assets was removed from the asset group'
	});

	if (deactivatedBySystem) {
		return (
			<FontAwesomeIcon
				icon={faExclamationTriangle}
				size={'lg'}
				color={'black'}
				style={{
					marginBottom: '5px',
					marginRight: '7px'
				}}
				title={mouseHoverText}
			/>
		);
	} else {
		return null;
	}
};

export default RuleDeactivationWarning;
